// extracted by mini-css-extract-plugin
export default {"categorias":"styles_categorias__PUXaV","conteudo":"styles_conteudo__MW3kt","customCheckbox":"styles_customCheckbox__OzGGX"};